import api from "./axios";

// Aktif oyunları listeleme
export const getActiveGames = async () => {
    try {
        const response = await api.post("api/v1/Games/list/active");
        return response.data; // { status, message, count, data: [...] }
    } catch (error) {
        throw error.response?.data || { message: "Aktif oyunlar getirilemedi!" };
    }
};

// Tüm oyunları listeleme
export const getAllGames = async () => {
    try {
        const response = await api.post("api/v1/Games/list");
        return response.data; // Expected: [{...}, {...}] OR { data: [...] } depending on backend.
    } catch (error) {
        throw error.response?.data || { message: "Oyun listesi getirilemedi!" };
    }
};

// Oyun Ekleme
export const addGame = async (gameData) => {
    try {
        const response = await api.post("api/v1/Games/add", gameData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Oyun eklenemedi!" };
    }
};

// Oyun Durum Değiştirme
export const toggleGameStatus = async (id, isActive) => {
    try {
        const response = await api.put("api/v1/Games/GameActivate", { id, isActive });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Durum değiştirilemedi!" };
    }
};

// Redis'e Veri Aktarma
export const syncGameToRedis = async (gameKey) => {
    try {
        let url = `api/v1/${gameKey}/data-to-redis-${gameKey}`;

        // WordMatches için özel URL yapısı (v1 olmadan)
        if (gameKey === 'WordMatches') {
            url = `api/WordMatches/data-to-redis-WordMatches`;
        }

        const response = await api.post(url);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Redis aktarımı başarısız!" };
    }
};
